
import api from "../api";

const REFRESH_BUFFER = 30; 
let refreshTimeout = null;
let isRefreshing = false;
let refreshSubscribers = [];

export function decodeJWT(token) {
    try {
        const payload = token.split(".")[1];
        return JSON.parse(atob(payload));
    } catch (error) {
        console.error("❌ Invalid JWT token:", error);
        return null;
    }
}

function onRefreshed(token) {
    refreshSubscribers.forEach(cb => cb(token));
    refreshSubscribers = [];
}

export async function logoutAndRedirect(reason = "session_expired") {
        if (refreshTimeout) {
        clearTimeout(refreshTimeout);
        refreshTimeout = null;
    }

    try {
        await api.post("/api/auth/logout");
    } catch (error) {
        console.warn("⚠️ Failed to notify backend on logout:", error);
    }

    localStorage.removeItem("authToken");
    window.location.href = `/login?error=${reason}`;
}

async function performTokenRefresh() {
    if (isRefreshing) {
        return new Promise(resolve => {
            refreshSubscribers.push(resolve);
        });
    }

    isRefreshing = true;

    try {
        console.log("🔃 Attempting token refresh...");
        const { data } = await api.post("/api/auth/refreshAccessToken");

        if (data?.accessToken) {
            localStorage.setItem("authToken", data.accessToken);
            api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
            console.log("🔄 Token refreshed successfully");
            onRefreshed(data.accessToken);
            scheduleTokenRefresh(data.accessToken);
            return data.accessToken;
        }
        throw new Error("No access token received");
    } catch (err) {
        console.error("❌ Token refresh failed:", err.message);
        logoutAndRedirect("session_expired");
        throw err;
    } finally {
        isRefreshing = false;
    }
}

export function scheduleTokenRefresh(token) {
      if (refreshTimeout) {
        clearTimeout(refreshTimeout);
    }

    if (!token) {
        console.warn("⛔ No token provided to refresh scheduler");
        return;
    }

    const decoded = decodeJWT(token);
    const now = Math.floor(Date.now() / 1000);
    const exp = decoded?.exp;

    if (!exp) {
        console.warn("⛔ Token has no expiry");
        return;
    }

    if (exp < now) {
        console.warn("⛔ Token is already expired");
        performTokenRefresh().catch(() => { });
        return;
    }

    const refreshInSeconds = exp - now - REFRESH_BUFFER;

    if (refreshInSeconds <= 0) {
        console.warn("⚠️ Token is too close to expiry - refreshing now");
        performTokenRefresh().catch(() => { });
        return;
    }

    console.log(`⏳ Scheduled refresh in ${refreshInSeconds} seconds`);
    refreshTimeout = setTimeout(performTokenRefresh, refreshInSeconds * 1000);
}

export async function refreshToken() {
    return performTokenRefresh();
}